import React, { Component } from 'react';
import { Icon } from '@alifd/next';
import classNames from 'classnames';
import './index.scss';

class NavSlider extends Component {
  constructor(props) {
    super(props);

    this.state = {
      maxOffset: 0,
      offset: 0,
    };

    this.doms = {};
  }

  componentDidMount() {
    this.checkHasNav();
    this.checkActiveInview();

    // 字体加载后元素宽度会发生变化
    try {
      document.fonts.ready.then(() => this.checkHasNav());
    } catch (err) {
      // ...
    }
    window.addEventListener('load', () => this.checkHasNav());
  }

  componentDidUpdate(prevProps) {
    if (this.props.navs !== prevProps.navs) {
      this.checkHasNav();
      this.checkActiveInview();
      return;
    }
    if (this.props.active !== prevProps.active) {
      this.checkActiveInview();
    }
  }

  onPrevClick = () => {
    if (!this.elWrapper) {
      return;
    }
    const { offset } = this.state;
    this.setState({
      offset: this.getSafeOffset(offset - this.elWrapper.clientWidth),
    });
  };

  onNextClick = () => {
    if (!this.elWrapper) {
      return;
    }
    const { offset } = this.state;
    this.setState({
      offset: this.getSafeOffset(offset + this.elWrapper.clientWidth),
    });
  };

  onClick(id) {
    const { onChange } = this.props;
    onChange && onChange(id);
  }

  onItemRendered(id, dom) {
    this.doms[id] = dom;
  }

  getSafeOffset(offset) {
    const { maxOffset } = this.state;
    if (offset < 0 || !maxOffset) {
      return 0;
    }

    if (offset > maxOffset) {
      return maxOffset;
    }

    return offset;
  }

  checkHasNav() {
    if (!this.elWrapper || !this.elList) {
      return;
    }

    const wrapperWidth = this.elWrapper.clientWidth;
    const totalWidth = this.elList.clientWidth;
    const maxOffset = totalWidth - wrapperWidth;
    this.setState({ maxOffset: maxOffset > 0 ? maxOffset : 0 });
  }

  checkActiveInview() {
    const { active } = this.props;
    const { maxOffset, offset } = this.state;
    if (!maxOffset || !this.doms[active] || !this.elWrapper) {
      return;
    }

    const activeRect = this.doms[active].getBoundingClientRect();
    const wrapperRect = this.elWrapper.getBoundingClientRect();
    let newOffset;
    if (activeRect.left < wrapperRect.left) {
      newOffset = offset - (wrapperRect.left - activeRect.left);
      this.setState({ offset: this.getSafeOffset(newOffset) });
      return;
    }
    if (activeRect.right > wrapperRect.right) {
      newOffset = offset + (activeRect.right - wrapperRect.right);
      this.setState({ offset: this.getSafeOffset(newOffset) });
    }
  }

  render() {
    const { className, navs, active } = this.props;
    const { maxOffset, offset } = this.state;
    const cls = classNames({
      'bc-nav-slider': true,
      [className]: className,
    });

    return (
      <div className={cls}>
        <div className="nav-wrapper" ref={el => (this.elWrapper = el)}>
          <ul
            className="nav-list"
            ref={el => (this.elList = el)}
            style={offset ? { marginLeft: -offset } : null}
          >
            {navs.map((item, index) => (
              <li
                className={classNames({
                  'nav-item': true,
                  active: active === item.id,
                })}
                onClick={this.onClick.bind(this, item.id)}
                key={index}
                ref={this.onItemRendered.bind(this, item.id)}
              >
                {item.text}
              </li>
            ))}
          </ul>
        </div>
        {maxOffset > 0 && (
          <div className="nav-arrows">
            <Icon
              className={classNames({
                arrow: true,
                prev: true,
                disabled: !offset,
              })}
              type="arrow-left"
              size="xs"
              onClick={this.onPrevClick}
            />
            <Icon
              className={classNames({
                arrow: true,
                next: true,
                disabled: offset >= maxOffset,
              })}
              type="arrow-right"
              size="xs"
              onClick={this.onNextClick}
            />
          </div>
        )}
      </div>
    );
  }
}

export default NavSlider;
